import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const insightsKpis /*: WarehouseKPI[] */ = [
  // [MIGRATION] All 'insights' KPIs from kpiCatalogue.ts, updated to EnhancedBenchmark structure.
  // ... KPIs will be inserted here ...
  // Pick Path Efficiency
  {
    id: 'pick_path_efficiency',
    category: 'insights',
    title: 'Pick Path Efficiency',
    description: 'Ratio of actual pick path distance to optimal pick path',
    unit: '%',
    formula:
      'SUM(optimal_pick_path_distance) / SUM(actual_pick_path_distance) * 100',
    tags: ['picking', 'efficiency', 'digital_twin_simulation'],
    benchmark: {
      standards: {
        site: {
          target: 90,
          warning: { lower: 80 },
          critical: { lower: 70 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 70 },
            { label: 'Warning', min: 70.01, max: 80 },
            { label: 'Target', min: 80.01, max: 90 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['zone', 'order_size', 'picker_id'],
    alertTopic: 'warehouse.alerts.insights.pick_path',
    processType: ActivityEventProcessType.PICKING,
  },
  // ... (repeat for all insights KPIs, converting each benchmark) ...
];

export default insightsKpis;
